module.exports = __webpack_public_path__ + "img/3.6664dc9a.png";